import { memo } from 'react';

import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';

import { EntityFilter } from '../FiltersBlock';

const ExpediaReviewFilterDesktop = dynamic(
  () => import('./ExpediaReviewFilterDesktop'),
  {
    ssr: false,
  }
);

const ExpediaReviewFilterMobile = dynamic(
  () => import('./ExpediaReviewFilterMobile'),
  {
    ssr: false,
  }
);
export interface NameFilterProps {
  title?: string;
  point?: EntityFilter[];
  handleSelectedItems?: (item: string) => void;
  selectedItems?: string | string[];
}

const ExpediaReviewFilter = ({
  title,
  point,
  handleSelectedItems,
  selectedItems,
}: NameFilterProps) => {
  const { isDesktop } = useDevice();

  const getPointText = (point: number) => {
    if (point >= 4 && point < 5) return 'Harika 4+';
    if (point >= 3 && point <= 4) return 'Çok İyi 3+';
    if (point >= 2 && point <= 3) return 'İyi 2+';
    if (point >= 1 && point <= 2) return 'Orta 1+';
    if (point === 5) return 'Mükemmel 5';
  };

  return isDesktop ? (
    <ExpediaReviewFilterDesktop
      title={title}
      point={point}
      handleSelectedItems={handleSelectedItems}
      selectedItems={selectedItems}
      getPointText={getPointText}
    />
  ) : (
    <ExpediaReviewFilterMobile
      title={title}
      point={point}
      handleSelectedItems={handleSelectedItems}
      selectedItems={selectedItems}
      getPointText={getPointText}
    />
  );
};

export default memo(ExpediaReviewFilter);
